import { defineMessages } from 'react-intl';

export default defineMessages({
  'paymentFailure.card_declined.insufficient_funds': {
    id: 'paymentFailure.card_declined.insufficient_funds',
    defaultMessage: 'Your card has insufficient funds.',
  },

  pay: {
    id: 'components.myaccount.claims.confirmation.paymentForm.pay',
    defaultMessage: 'Pay {amount}',
  },
  creditCardHolder: {
    id: 'components.myaccount.claims.confirmation.paymentForm.creditCardHolder',
    defaultMessage: "Cardholder's name",
  },
  expirationDate: {
    id: 'components.myaccount.claims.confirmation.paymentForm.expirationDate',
    defaultMessage: 'Expiration date',
  },
  cardNumber: {
    id: 'components.myaccount.claims.confirmation.paymentForm.cardNumber',
    defaultMessage: 'Card number',
  },
  cardCvv: {
    id: 'components.myaccount.claims.confirmation.paymentForm.cardCvv',
    defaultMessage: 'Card CVV',
  },
  expirationOutOfRangeError: {
    id: 'components.myaccount.claims.confirmation.paymentForm.expirationOutOfRangeError',
    defaultMessage: 'Expiration date is out of range',
  },
  panFormatError: {
    id: 'components.myaccount.claims.confirmation.paymentForm.panFormatError',
    defaultMessage: 'Card number is not valid',
  },
  expirationFormatError: {
    id: 'components.myaccount.claims.confirmation.paymentForm.expirationFormatError',
    defaultMessage: 'Expiration date is not valid',
  },
  cvvFormatError: {
    id: 'components.myaccount.claims.confirmation.paymentForm.cvvFormatError',
    defaultMessage: 'CVV format is not valid',
  },
  paymentFailure: {
    id: 'view.paymentMonext.paymentFailure',
    defaultMessage: 'Payment failure',
  },
  paymentSuccess: {
    id: 'view.paymentMonext.paymentSuccess',
    defaultMessage: 'Payment success',
  },
  panPlaceholder: {
    id: 'view.paymentMonext.panPlaceholder',
    defaultMessage: 'XXXX XXXX XXXX XXXX',
  },
  expirationPlaceholder: {
    id: 'view.paymentMonext.expirationPlaceholder',
    defaultMessage: 'MM/YY',
  },
  cvvPlaceholder: {
    id: 'view.paymentMonext.cvvPlaceholder',
    defaultMessage: 'Cvv placeholder',
  },
  cvv4Placeholder: {
    id: 'view.paymentMonext.cvv4Placeholder',
    defaultMessage: 'Cvv4 placeholder',
  },

  cbx2: {
    id: 'view.paymentPurse.cbx2',
    defaultMessage: 'Pay x2',
  },
  cb3x: {
    id: 'view.paymentPurse.cbx3',
    defaultMessage: 'Pay x3',
  },
  cb4x: {
    id: 'view.paymentPurse.cbx4',
    defaultMessage: 'Pay x4',
  },
  creditCard: {
    id: 'view.paymentPurse.CreditCard',
    defaultMessage: 'CreditCard',
  },
  sepa: {
    id: 'view.paymentPurse.sepa',
    defaultMessage: 'Sepa',
  },

  cb2xDescription: {
    id: 'components.myaccount.claims.confirmation.paymentForm.cb2xDescription',
    defaultMessage: 'Ccb2x description',
  },
  cb3xDescription: {
    id: 'components.myaccount.claims.confirmation.paymentForm.cb3xDescription',
    defaultMessage: 'Ccb3x description',
  },
  cb4xDescription: {
    id: 'components.myaccount.claims.confirmation.paymentForm.cb4xDescription',
    defaultMessage: 'Ccb4x description',
  },
  bancontactDescription: {
    id: 'components.myaccount.claims.confirmation.paymentForm.bancontactDescription',
    defaultMessage: 'Bancontact Description',
  },
  paybylinkDescription: {
    id: 'components.myaccount.claims.confirmation.paymentForm.paybylinkDescription',
    defaultMessage: 'PayBy link',
  },
  sepaDescription: {
    id: 'components.myaccount.claims.confirmation.paymentForm.sepaDescription',
    defaultMessage: 'SepaDescription',
  },
  transactionInProgress: {
    id: 'view.paymentPurse.transactionInProgress',
    defaultMessage: 'Transaction in progress',
  },
});
